const SEARCH_FILTERS = {
  name_cont: ''
}

export default { SEARCH_FILTERS }
